import {
  LEGAL_UPDATE_DATE,
  PRIVACY_POLICY_CONTENT,
  TERMS_CONTENT,
} from "./legalContent";

const LEGAL_CONTENT_BY_KIND = {
  privacy: PRIVACY_POLICY_CONTENT,
  terms: TERMS_CONTENT,
};

function LegalList({ items }) {
  if (!items?.length) return null;

  return (
    <ol className="legal-page__list">
      {items.map((item, index) => (
        <li key={item}>
          <span>{String.fromCharCode(97 + index)})</span>
          {item}
        </li>
      ))}
    </ol>
  );
}

function LegalParagraphs({ paragraphs }) {
  if (!paragraphs?.length) return null;

  return paragraphs.map((paragraph) => (
    <p key={paragraph}>{paragraph}</p>
  ));
}

function LegalSection({ section }) {
  return (
    <section className="legal-page__section">
      <h2>{section.title}</h2>
      <LegalParagraphs paragraphs={section.paragraphs} />
      <LegalList items={section.items} />
      {section.subsections?.map((subsection) => (
        <section className="legal-page__subsection" key={subsection.title}>
          <h3>{subsection.title}</h3>
          <LegalParagraphs paragraphs={subsection.paragraphs} />
          <LegalList items={subsection.items} />
        </section>
      ))}
      <LegalParagraphs paragraphs={section.closing} />
    </section>
  );
}

export default function LegalPage({ kind, onBack }) {
  const content = LEGAL_CONTENT_BY_KIND[kind] || TERMS_CONTENT;

  return (
    <main className="legal-page" aria-labelledby="legal-page-title">
      <header className="landing-header legal-page__header">
        <nav className="landing-nav legal-page__nav" aria-label="Navegação legal">
          <div className="landing-brand">
            <img
              src={`${process.env.PUBLIC_URL || ""}/suptracker.png`}
              alt=""
              className="landing-brand__logo"
            />
            <span>orion33</span>
          </div>

          <h1 id="legal-page-title" className="legal-page__header-title">
            {content.title}
          </h1>

          <div className="landing-nav__actions">
            <button
              className="landing-nav__login"
              type="button"
              onClick={onBack}
            >
              Voltar
            </button>
          </div>
        </nav>
      </header>

      <article className="legal-page__content">
        <p className="legal-page__eyebrow">{content.eyebrow}</p>
        <p className="legal-page__updated">
          Última atualização: {LEGAL_UPDATE_DATE}
        </p>
        <LegalParagraphs paragraphs={content.intro} />
        {content.sections.map((section) => (
          <LegalSection section={section} key={section.title} />
        ))}
      </article>
    </main>
  );
}
